import { getReportParams, report } from '../../middleware/report';

export function createReport(dwhDetails) {
  let reportParams = getReportParams();
  reportParams.area = dwhDetails.area;
  reportParams.subArea = dwhDetails.subArea;
  reportParams.channel = dwhDetails.channel;
  reportParams.status = dwhDetails.status;
  reportParams.customerName = dwhDetails.customerName;
  reportParams.subscriber = dwhDetails.subscriber;
  reportParams.idNumber = dwhDetails.contactId;
  reportParams.actionType = dwhDetails.actionType;
  reportParams.messageText = dwhDetails.messageText;
  reportParams.param1 = dwhDetails.param1;
  reportParams.param2 = dwhDetails.param2;
  reportParams.param3 = dwhDetails.param3;
  reportParams.param4 = dwhDetails.param4;
  reportParams.param5 = dwhDetails.param5;
  reportParams.param6 = dwhDetails.param6;
  reportParams.param7 = dwhDetails.param7;
  reportParams.param8 = dwhDetails.param8;
  reportParams.param9 = dwhDetails.param9;
  reportParams.param10 = dwhDetails.param10;
  reportParams.banId = dwhDetails.banId;
  reportParams.psId = dwhDetails.psId;
  reportParams.cmrId = dwhDetails.cmrId;
  reportParams.email = dwhDetails.email;

  report(reportParams);
}

export const createReportDevicesAndEquipments = (type, itemName) => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Device Order';
  reportParams.channel = 'WebsitePrivate';
  reportParams.status = 'Ongoing';
  reportParams.actionType = 'My Zone Lobby';
  reportParams.messageText = 'Device Order Page Displayed';
  reportParams.param1 = '';
  if (type == 'Info Link Clicked') {
    reportParams.messageText = 'Info Link Clicked';
    reportParams.param1 = itemName;
  } else if (type == 'Device Order Button Clicked') {
    reportParams.messageText = 'Device Order Button Clicked';
    reportParams.param1 = itemName;
  }
  report(reportParams);
};

export const createReportPopuopDevices = (actionType, productInfoInput) => {

  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Device Order';
  reportParams.channel = 'WebsitePrivate';
  reportParams.status = 'Ongoing';
  reportParams.actionType = 'Are You Sure PopUp';
  reportParams.messageText = 'Are You Sure PopUp Displayed';
  reportParams.param1 = productInfoInput?.value;

  if (actionType == 'Yes Clicked') {
    reportParams.messageText = 'Yes Clicked';
  } else if (actionType == 'No Clicked') {
    reportParams.messageText = 'No Clicked';
  } else if (actionType == 'Success') {
    reportParams.messageText = 'Success';
    reportParams.status = 'Completed';
    reportParams.actionType = 'Sending Order';
  } else if (actionType == 'Fail') {
    reportParams.messageText = 'General Error';
    reportParams.status = 'Error';
    reportParams.actionType = 'Sending Order';
  }

  report(reportParams);
};

export const createReportFuturePayments = (text, customerName, contactNumber, idNumber, orgId) => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Device Payments';
  reportParams.channel = 'WebsitePrivate';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = idNumber;
  reportParams.actionType = 'Device Payments Page';
  reportParams.messageText = text;
  reportParams.param3 = orgId?.join(",");

  report(reportParams);
};

export const createReportUpgradeCellular = () => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Device Order';
  reportParams.channel = 'WebsitePrivate';
  reportParams.status = 'Ongoing';
  reportParams.actionType = 'Device Order Page';
  reportParams.messageText = 'Device Order Page Displayed';
  report(reportParams);
};

export const createReportSelfCareArea = (
  customerNameReport,
  subscriberReport,
  IDNumber,
  customerAccount,
  organizationCodeList,
  numberOFUpdatesInTracker,
  numberOfInvoices,
  productsFlag
) => {
  let reportParams = getReportParams();
  reportParams.param3 = '';
  reportParams.param3 = organizationCodeList?.join(",");
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'My Zone';
  reportParams.channel = 'WebsitePrivate';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerNameReport;
  reportParams.subscriber = subscriberReport;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'My Zone Lobby';
  reportParams.messageText = 'My Zone Lobby Displayed';
  reportParams.param1 = '';
  reportParams.param2 = customerAccount;
  reportParams.param4 = 'כמות עדכונים:' + numberOFUpdatesInTracker;
  reportParams.param5 = 'כמות חשבוניות שהוצגו: ' + numberOfInvoices;
  reportParams.param6 = productsFlag;
  report(reportParams);
};

export const createReportUpgradeCellularDeviceOrderPage = (type, itemName) => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Device Order';
  reportParams.channel = 'WebsitePrivate';
  reportParams.status = 'Ongoing';
  reportParams.actionType = 'Device Order Page';
  reportParams.messageText = 'Device Order Page Displayed';
  reportParams.param1 = '';
  if (type == 'Info Link Clicked') {
    reportParams.messageText = 'Info Link Clicked';
    reportParams.param1 = itemName;
  } else if (type == 'Device Order Button Clicked') {
    reportParams.messageText = 'Device Order Button Clicked';
    reportParams.param1 = itemName;
  }
  report(reportParams);
};

export const createReportUpgradeCellularDeviceClickBtn = (type, itemName) => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Device Order';
  reportParams.channel = 'WebsitePrivate';
  reportParams.status = 'Ongoing';
  reportParams.actionType = 'Device Order Page';
  reportParams.messageText = 'Device Order Page Displayed';
  reportParams.param1 = '';
  if (type == 'Info Link Clicked') {
    reportParams.messageText = 'Info Link Clicked';
    reportParams.param1 = itemName;
  } else if (type == 'Device Order Button Clicked') {
    reportParams.messageText = 'Device Order Button Clicked';
    reportParams.param1 = itemName;
  }
  report(reportParams);
};

export const createReportPreviousInvoicesClicked = (customerName, contactNumber, IDNumber, ban) => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'My Zone';
  reportParams.channel = 'WebsitePrivate';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.banId = ban;
  reportParams.actionType = 'My Zone Lobby';
  reportParams.messageText = 'Previous Bill Displayed';
  report(reportParams);
};

export const createReportUpdateCellularPlan = (
  reportType,
  UpdateOfferID,
  CurrentOfferID,
  CurrentOfferFlag,
  customerName,
  subscriber,
  idNumber,
) => {
  let reportParams = getReportParams();
  reportParams.param6 = 'Current Offer is fixed Price Customer Level';
  if (CurrentOfferFlag == 'N') {
    reportParams.param6 = 'Current Offer is flex Price Customer Level';
  }
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Change Price Plan';
  reportParams.channel = 'Website';
  reportParams.status = 'Completed';
  reportParams.customerName = customerName;
  reportParams.subscriber = subscriber;
  reportParams.idNumber = idNumber;
  reportParams.actionType = 'Update Change Price Plan';
  reportParams.messageText = 'Success';
  reportParams.param1 = UpdateOfferID;
  reportParams.param2 = CurrentOfferID;
  if (reportType == 'Error') {
    reportParams.status = 'Error';
    reportParams.messageText = 'Max Family Count Exceeded';
  }

  report(reportParams);
};

export const createReportIdfPackageExtensionPageDisplayed = (customerName, contactNumber, IDNumber) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFBrowsingData';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Browsing data Package details page';
  reportParams.messageText = 'Subscriber pressed page Displayed';
  reportParams.param1 = contactNumber;
  report(reportParams);
}

export const createReportIdfPackageExtensionPurchase = (customerName, contactNumber, IDNumber, packageId) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFBrowsingData';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Browsing data Package details page';
  reportParams.messageText = 'Subscribe Click to purchase a browsing extension';
  reportParams.param1 = contactNumber;
  reportParams.param2 = packageId;
  report(reportParams);
}

export const createReportIdfPackageExtensionGeneralError = (customerName, contactNumber, IDNumber) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFBrowsingData';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Error';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Browsing data Browsing extension';
  reportParams.messageText = 'General Error';
  reportParams.param1 = contactNumber;
  report(reportParams);
}

export const createReportIdfPackageExtensionSuccess = (customerName, contactNumber, IDNumber, packageId) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFBrowsingData';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Completed';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Browsing data Browsing extension';
  reportParams.messageText = 'Success';
  reportParams.param1 = contactNumber;
  reportParams.param2 = packageId;
  report(reportParams);
}

export const createReportIdfNewPlanSignupChoosePackagePageDisplayed = (customerName, contactNumber, IDNumber) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDF Registration Your Plan an Existing Soldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Choose Package';
  reportParams.messageText = 'Choose Package Page Displayed';
  report(reportParams);
}

export const createReportIdfNewPlanSignupSelectedPackage = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDF Registration Your Plan an Existing Soldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Choose Package';
  reportParams.messageText = 'Selected package';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

export const createReportIdfNewPlanSignupGeneralError = (customerName, contactNumber, IDNumber, packageId = '', packagePrice ='') => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFRegistrationGeneralErrorExistingSoldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Error';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'General Error';
  reportParams.messageText = 'General Error';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

export const createReportIdfNewPlanSignupContinueToStep2 = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDF Registration Your Plan an Existing Soldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Choose Package';
  reportParams.messageText = 'continue button clicked';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

export const createReportIdfNewPlanSignupPersonalInformationPageDisplayed = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFRegistrationPersonalInformationExistingSoldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Personal Information';
  reportParams.messageText = 'Personal Information Page Displayed';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

//Approval tender summary form
export const createReportIdfNewPlanSignupApprovalTenderSummary = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFRegistrationPersonalInformationExistingSoldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Personal Information';
  reportParams.messageText = 'Approval tender summary form';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

//Approval information security form
export const createReportIdfNewPlanSignupApprovalInformationSecurity = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFRegistrationPersonalInformationExistingSoldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Personal Information';
  reportParams.messageText = 'Approval information security form';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

//join form clicked
export const createReportIdfNewPlanSignupSignupFormClick = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFRegistrationPersonalInformationExistingSoldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Personal Information';
  reportParams.messageText = 'Join form clicked';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

//continue button clicked
export const createReportIdfNewPlanSignupContinueToStep3 = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFRegistrationPersonalInformationExistingSoldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Personal Information';
  reportParams.messageText = 'continue button clicked';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

//Order Confirmation Page Displayed
export const createReportIdfNewPlanSignupOrderConfirmationPageDisplayed = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFRegistrationOrderConfirmationExistingSoldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Order Confirmation';
  reportParams.messageText = 'Order Confirmation Page Displayed';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

//Order Confirmation Page Edit button clicked
export const createReportIdfNewPlanSignupOrderConfirmationPageEditButtonClicked = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFRegistrationOrderConfirmationExistingSoldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Ongoing';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Order Confirmation';
  reportParams.messageText = 'Order Confirmation Page Edit button clicked';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

//Order Confirmation Page button clicked
export const createReportIdfNewPlanSignupOrderConfirmationPageButtonClicked = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFRegistrationOrderConfirmationExistingSoldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Completed';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Order Confirmation';
  reportParams.messageText = 'Order Confirmation Page button clicked';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

//Order summary Page Displayed
export const createReportIdfNewPlanSignupOrderSummaryPageDisplayed = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFRegistrationOrderSummaryExistingSoldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Completed';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Order Summary';
  reportParams.messageText = 'Order Summary Page Displayed';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

//Order summary button clicked
export const createReportIdfNewPlanSignupOrderSummaryPageButtonClicked = (customerName, contactNumber, IDNumber, packageId, packagePrice) => {
  let reportParams = getReportParams();
  reportParams.area = 'IDF';
  reportParams.subArea = 'IDFRegistrationOrderSummaryExistingSoldier';
  reportParams.channel = 'WebsiteIDF';
  reportParams.status = 'Completed';
  reportParams.customerName = customerName;
  reportParams.subscriber = contactNumber;
  reportParams.idNumber = IDNumber;
  reportParams.actionType = 'Ordersummary';
  reportParams.messageText = 'Order Summary Page button clicked';
  reportParams.param1 = packageId;
  reportParams.param2 = packagePrice;
  report(reportParams);
}

